import { render, staticRenderFns } from "./TransitionExpandHeight.vue?vue&type=template&id=2abc3085&"
import script from "./TransitionExpandHeight.vue?vue&type=script&lang=ts&"
export * from "./TransitionExpandHeight.vue?vue&type=script&lang=ts&"
import style0 from "./TransitionExpandHeight.vue?vue&type=style&index=0&id=2abc3085&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports